import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _709c77f0 = () => interopDefault(import('../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _51554ca0 = () => interopDefault(import('../pages/calls/index.vue' /* webpackChunkName: "pages/calls/index" */))
const _bfe26d9a = () => interopDefault(import('../pages/holidays.vue' /* webpackChunkName: "pages/holidays" */))
const _43af7491 = () => interopDefault(import('../pages/overview.vue' /* webpackChunkName: "pages/overview" */))
const _6fdb8c7e = () => interopDefault(import('../pages/settings/index.vue' /* webpackChunkName: "pages/settings/index" */))
const _1ceccd95 = () => interopDefault(import('../pages/setup.vue' /* webpackChunkName: "pages/setup" */))
const _4ccaf029 = () => interopDefault(import('../pages/tasks/index.vue' /* webpackChunkName: "pages/tasks/index" */))
const _15a2b9ff = () => interopDefault(import('../pages/account/callback.vue' /* webpackChunkName: "pages/account/callback" */))
const _7530a634 = () => interopDefault(import('../pages/account/cancel.vue' /* webpackChunkName: "pages/account/cancel" */))
const _0f95753e = () => interopDefault(import('../pages/account/check.vue' /* webpackChunkName: "pages/account/check" */))
const _a3ef4f34 = () => interopDefault(import('../pages/account/email-verification.vue' /* webpackChunkName: "pages/account/email-verification" */))
const _11165e6e = () => interopDefault(import('../pages/account/export.vue' /* webpackChunkName: "pages/account/export" */))
const _45a466d3 = () => interopDefault(import('../pages/account/invitation.vue' /* webpackChunkName: "pages/account/invitation" */))
const _5fe48420 = () => interopDefault(import('../pages/account/invoices.vue' /* webpackChunkName: "pages/account/invoices" */))
const _cd22ef98 = () => interopDefault(import('../pages/account/link.vue' /* webpackChunkName: "pages/account/link" */))
const _dd4d31c2 = () => interopDefault(import('../pages/account/login.vue' /* webpackChunkName: "pages/account/login" */))
const _395dd34c = () => interopDefault(import('../pages/account/login-error.vue' /* webpackChunkName: "pages/account/login-error" */))
const _356123bc = () => interopDefault(import('../pages/account/payment.vue' /* webpackChunkName: "pages/account/payment" */))
const _c86e1c42 = () => interopDefault(import('../pages/account/profile.vue' /* webpackChunkName: "pages/account/profile" */))
const _33a52c5c = () => interopDefault(import('../pages/account/signup.vue' /* webpackChunkName: "pages/account/signup" */))
const _20297c24 = () => interopDefault(import('../pages/account/switch.vue' /* webpackChunkName: "pages/account/switch" */))
const _22679dd2 = () => interopDefault(import('../pages/account/team.vue' /* webpackChunkName: "pages/account/team" */))
const _425e7385 = () => interopDefault(import('../pages/account/user.vue' /* webpackChunkName: "pages/account/user" */))
const _0217fd08 = () => interopDefault(import('../pages/settings/blocking/index.vue' /* webpackChunkName: "pages/settings/blocking/index" */))
const _a16aaacc = () => interopDefault(import('../pages/settings/dictionary.vue' /* webpackChunkName: "pages/settings/dictionary" */))
const _5bc18695 = () => interopDefault(import('../pages/settings/information-card.vue' /* webpackChunkName: "pages/settings/information-card" */))
const _f685ab6c = () => interopDefault(import('../pages/settings/notification-rule.vue' /* webpackChunkName: "pages/settings/notification-rule" */))
const _9def6ed0 = () => interopDefault(import('../pages/settings/processing-status.vue' /* webpackChunkName: "pages/settings/processing-status" */))
const _21559f5e = () => interopDefault(import('../pages/settings/sensitive-words.vue' /* webpackChunkName: "pages/settings/sensitive-words" */))
const _3870e168 = () => interopDefault(import('../pages/settings/verify-email.vue' /* webpackChunkName: "pages/settings/verify-email" */))
const _0d7c2518 = () => interopDefault(import('../pages/settings/voice-message.vue' /* webpackChunkName: "pages/settings/voice-message" */))
const _c8084a38 = () => interopDefault(import('../pages/settings/blocking/list.vue' /* webpackChunkName: "pages/settings/blocking/list" */))
const _7ec64a37 = () => interopDefault(import('../pages/settings/notifications/chatwork/index.vue' /* webpackChunkName: "pages/settings/notifications/chatwork/index" */))
const _d2530eb8 = () => interopDefault(import('../pages/settings/notifications/email/index.vue' /* webpackChunkName: "pages/settings/notifications/email/index" */))
const _388d15b4 = () => interopDefault(import('../pages/settings/notifications/google-chat/index.vue' /* webpackChunkName: "pages/settings/notifications/google-chat/index" */))
const _14e9cb82 = () => interopDefault(import('../pages/settings/notifications/line/index.vue' /* webpackChunkName: "pages/settings/notifications/line/index" */))
const _579dab4b = () => interopDefault(import('../pages/settings/notifications/line-works-app/index.vue' /* webpackChunkName: "pages/settings/notifications/line-works-app/index" */))
const _744e21c2 = () => interopDefault(import('../pages/settings/notifications/microsoft-teams/index.vue' /* webpackChunkName: "pages/settings/notifications/microsoft-teams/index" */))
const _482c28d0 = () => interopDefault(import('../pages/settings/notifications/slack/index.vue' /* webpackChunkName: "pages/settings/notifications/slack/index" */))
const _0be7b4c5 = () => interopDefault(import('../pages/settings/notifications/teams-workflows/index.vue' /* webpackChunkName: "pages/settings/notifications/teams-workflows/index" */))
const _e02aed2c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _de012342 = () => interopDefault(import('../pages/settings/notifications/chatwork/_id.vue' /* webpackChunkName: "pages/settings/notifications/chatwork/_id" */))
const _2a32540c = () => interopDefault(import('../pages/settings/notifications/email/_id.vue' /* webpackChunkName: "pages/settings/notifications/email/_id" */))
const _4fe615c8 = () => interopDefault(import('../pages/settings/notifications/google-chat/_id.vue' /* webpackChunkName: "pages/settings/notifications/google-chat/_id" */))
const _7eb7f71a = () => interopDefault(import('../pages/settings/notifications/line-works-app/_id.vue' /* webpackChunkName: "pages/settings/notifications/line-works-app/_id" */))
const _efce732c = () => interopDefault(import('../pages/settings/notifications/line/_id.vue' /* webpackChunkName: "pages/settings/notifications/line/_id" */))
const _2ec62d47 = () => interopDefault(import('../pages/settings/notifications/microsoft-teams/_id.vue' /* webpackChunkName: "pages/settings/notifications/microsoft-teams/_id" */))
const _40a41800 = () => interopDefault(import('../pages/settings/notifications/slack/_id.vue' /* webpackChunkName: "pages/settings/notifications/slack/_id" */))
const _40f6246d = () => interopDefault(import('../pages/settings/notifications/teams-workflows/_id.vue' /* webpackChunkName: "pages/settings/notifications/teams-workflows/_id" */))
const _e8ebc6ca = () => interopDefault(import('../pages/calls/_id/index.vue' /* webpackChunkName: "pages/calls/_id/index" */))
const _f22462d8 = () => interopDefault(import('../pages/tasks/_id/index.vue' /* webpackChunkName: "pages/tasks/_id/index" */))
const _20a73a54 = () => interopDefault(import('../pages/calls/_id/block.vue' /* webpackChunkName: "pages/calls/_id/block" */))
const _5bb6c0c9 = () => interopDefault(import('../pages/calls/_id/done.vue' /* webpackChunkName: "pages/calls/_id/done" */))
const _29dfd662 = () => interopDefault(import('../pages/tasks/_id/block.vue' /* webpackChunkName: "pages/tasks/_id/block" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/app/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _709c77f0,
    name: "account"
  }, {
    path: "/calls",
    component: _51554ca0,
    name: "calls"
  }, {
    path: "/holidays",
    component: _bfe26d9a,
    name: "holidays"
  }, {
    path: "/overview",
    component: _43af7491,
    name: "overview"
  }, {
    path: "/settings",
    component: _6fdb8c7e,
    name: "settings"
  }, {
    path: "/setup",
    component: _1ceccd95,
    name: "setup"
  }, {
    path: "/tasks",
    component: _4ccaf029,
    name: "tasks"
  }, {
    path: "/account/callback",
    component: _15a2b9ff,
    name: "account-callback"
  }, {
    path: "/account/cancel",
    component: _7530a634,
    name: "account-cancel"
  }, {
    path: "/account/check",
    component: _0f95753e,
    name: "account-check"
  }, {
    path: "/account/email-verification",
    component: _a3ef4f34,
    name: "account-email-verification"
  }, {
    path: "/account/export",
    component: _11165e6e,
    name: "account-export"
  }, {
    path: "/account/invitation",
    component: _45a466d3,
    name: "account-invitation"
  }, {
    path: "/account/invoices",
    component: _5fe48420,
    name: "account-invoices"
  }, {
    path: "/account/link",
    component: _cd22ef98,
    name: "account-link"
  }, {
    path: "/account/login",
    component: _dd4d31c2,
    name: "account-login"
  }, {
    path: "/account/login-error",
    component: _395dd34c,
    name: "account-login-error"
  }, {
    path: "/account/payment",
    component: _356123bc,
    name: "account-payment"
  }, {
    path: "/account/profile",
    component: _c86e1c42,
    name: "account-profile"
  }, {
    path: "/account/signup",
    component: _33a52c5c,
    name: "account-signup"
  }, {
    path: "/account/switch",
    component: _20297c24,
    name: "account-switch"
  }, {
    path: "/account/team",
    component: _22679dd2,
    name: "account-team"
  }, {
    path: "/account/user",
    component: _425e7385,
    name: "account-user"
  }, {
    path: "/settings/blocking",
    component: _0217fd08,
    name: "settings-blocking"
  }, {
    path: "/settings/dictionary",
    component: _a16aaacc,
    name: "settings-dictionary"
  }, {
    path: "/settings/information-card",
    component: _5bc18695,
    name: "settings-information-card"
  }, {
    path: "/settings/notification-rule",
    component: _f685ab6c,
    name: "settings-notification-rule"
  }, {
    path: "/settings/processing-status",
    component: _9def6ed0,
    name: "settings-processing-status"
  }, {
    path: "/settings/sensitive-words",
    component: _21559f5e,
    name: "settings-sensitive-words"
  }, {
    path: "/settings/verify-email",
    component: _3870e168,
    name: "settings-verify-email"
  }, {
    path: "/settings/voice-message",
    component: _0d7c2518,
    name: "settings-voice-message"
  }, {
    path: "/settings/blocking/list",
    component: _c8084a38,
    name: "settings-blocking-list"
  }, {
    path: "/settings/notifications/chatwork",
    component: _7ec64a37,
    name: "settings-notifications-chatwork"
  }, {
    path: "/settings/notifications/email",
    component: _d2530eb8,
    name: "settings-notifications-email"
  }, {
    path: "/settings/notifications/google-chat",
    component: _388d15b4,
    name: "settings-notifications-google-chat"
  }, {
    path: "/settings/notifications/line",
    component: _14e9cb82,
    name: "settings-notifications-line"
  }, {
    path: "/settings/notifications/line-works-app",
    component: _579dab4b,
    name: "settings-notifications-line-works-app"
  }, {
    path: "/settings/notifications/microsoft-teams",
    component: _744e21c2,
    name: "settings-notifications-microsoft-teams"
  }, {
    path: "/settings/notifications/slack",
    component: _482c28d0,
    name: "settings-notifications-slack"
  }, {
    path: "/settings/notifications/teams-workflows",
    component: _0be7b4c5,
    name: "settings-notifications-teams-workflows"
  }, {
    path: "/",
    component: _e02aed2c,
    name: "index"
  }, {
    path: "/settings/notifications/chatwork/:id",
    component: _de012342,
    name: "settings-notifications-chatwork-id"
  }, {
    path: "/settings/notifications/email/:id",
    component: _2a32540c,
    name: "settings-notifications-email-id"
  }, {
    path: "/settings/notifications/google-chat/:id?",
    component: _4fe615c8,
    name: "settings-notifications-google-chat-id"
  }, {
    path: "/settings/notifications/line-works-app/:id",
    component: _7eb7f71a,
    name: "settings-notifications-line-works-app-id"
  }, {
    path: "/settings/notifications/line/:id",
    component: _efce732c,
    name: "settings-notifications-line-id"
  }, {
    path: "/settings/notifications/microsoft-teams/:id?",
    component: _2ec62d47,
    name: "settings-notifications-microsoft-teams-id"
  }, {
    path: "/settings/notifications/slack/:id",
    component: _40a41800,
    name: "settings-notifications-slack-id"
  }, {
    path: "/settings/notifications/teams-workflows/:id?",
    component: _40f6246d,
    name: "settings-notifications-teams-workflows-id"
  }, {
    path: "/calls/:id",
    component: _e8ebc6ca,
    name: "calls-id"
  }, {
    path: "/tasks/:id",
    component: _f22462d8,
    name: "tasks-id"
  }, {
    path: "/calls/:id/block",
    component: _20a73a54,
    name: "calls-id-block"
  }, {
    path: "/calls/:id/done",
    component: _5bb6c0c9,
    name: "calls-id-done"
  }, {
    path: "/tasks/:id/block",
    component: _29dfd662,
    name: "tasks-id-block"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
